import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [time, setTime] = useState(10 * 60 + 48); // 10 minutes 48 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prev => prev > 0 ? prev - 1 : 10 * 60 + 48); // Reset loop for demo purposes
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 w-full bg-red-600 text-white z-50 py-2 px-4 shadow-md text-center font-bold text-sm md:text-base flex items-center justify-center gap-2 animate-pulse" data-id="element-175">
      <Clock className="w-4 h-4 md:w-5 md:h-5" data-id="element-176" />
      <span data-id="element-177">ESTA OFERTA TERMINA PRONTO:</span>
      <span className="bg-white text-red-600 px-2 py-0.5 rounded font-mono text-base md:text-lg" data-id="element-178">
        {formatTime(time)}
      </span>
    </div>;
}